export function seededRandom(seed) {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}

export function generateCountryDots(center, count, seed) {
  const rng = seededRandom(seed);
  const spreadLon = 4.2;
  const spreadLat = 3.0;
  const dotCount = Math.min(Math.max(Math.floor(count / 35), 8), 70);
  return Array.from({ length: dotCount }, () => {
    const u = rng() || 0.0001;
    const v = rng() || 0.0001;
    const nx = Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
    const ny = Math.sqrt(-2 * Math.log(u)) * Math.sin(2 * Math.PI * v);
    return {
      cx: center[0] + nx * spreadLon * 0.45,
      cy: center[1] + ny * spreadLat * 0.45,
      size: 0.8 + rng() * 1.2,
      opacity: 0.5 + rng() * 0.5,
    };
  });
}

export function generateStateDots(stateCenter, count, spread, seed) {
  const rng = seededRandom(seed);
  const dotCount = Math.min(Math.max(Math.floor(count / 12), 5), 40);
  return Array.from({ length: dotCount }, () => {
    const u = rng() || 0.0001;
    const v = rng() || 0.0001;
    const nx = Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
    const ny = Math.sqrt(-2 * Math.log(u)) * Math.sin(2 * Math.PI * v);
    return {
      cx: stateCenter[0] + nx * spread[0] * 0.5,
      cy: stateCenter[1] + ny * spread[1] * 0.5,
      size: 0.6 + rng() * 1.0,
      opacity: 0.55 + rng() * 0.45,
    };
  });
}
